@let localTopTen = topTen();
<div class="col-12">
  <div
    class="top10-header top10-header-polygon"
    [style.border-bottom]="'38px solid' + localTopTen?.label?.color"
  >
    <img
      [style]="{ 'max-width': '30px', 'max-heigth': '20px' }"
      [lazyLoad]="localTopTen?.label?.icon | cdnUrl: 100 : true"
    />
    <span>{{ localTopTen?.label?.language?.title }}</span>
  </div>
  <div class="box top10">
    <div class="row item-profile-little d-flex align-items-center">
      <div class="col-lg-3 col-md-3 col-12">
        <div class="item-image">
          <img
            class="w-100 adjust-top-ten"
            [lazyLoad]="localTopTen?.data?.image | cdnUrl: 400 : true"
          />
        </div>
      </div>
      <div class="col-lg-6 col-md-5 col-12">
        <div style="color: var(--negroClaro)" class="item-tittle mb-2 mt-2 mt-md-0 fw-bold">
          {{ localTopTen?.data?.language?.name }}
        </div>
        <div class="item-description mb-sm-1">
          {{
            (localTopTen?.data?.language?.description?.length || 0) > 140
              ? (localTopTen?.data?.language?.description | slice: 0 : 140) + '...'
              : localTopTen?.data?.language?.description
          }}
        </div>
      </div>
      <div class="d-grid gap-2 col-lg-3 col-md-4 col-12 left-border text-center">
        <app-rating
          class="d-block mb-2"
          [disabled]="true"
          [qualification]="localTopTen?.data?.qualification || 0"
        />
        <app-valoration class="d-block mb-2" [valuations]="localTopTen?.data?.valuations || 0" />
        <a (click)="goToTopten()" class="button success full">{{ '$ver_top' | translate }}</a>
      </div>
    </div>
  </div>
</div>
